const BASE = `${process.env.REACT_APP_MyAMP_Url}/api/ams/trucking-market`;

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface AppetiteDocument {
  id: string;
  fileName: string;
  createdDate?: string;
  downloadUrl?: string;
}

export async function getDocuments(): Promise<AppetiteDocument[]> {
  try {
    const res = await fetch(`${BASE}/documents-get`, { headers: authHeaders() });
    if (!res.ok) return [];
    const data = await res.json();
    return data.documents || data || [];
  } catch {
    return [];
  }
}

export async function uploadDocuments(files: File[]): Promise<void> {
  for (const file of files) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${BASE}/documents-upload`, {
      method: 'POST',
      headers: authHeaders(),
      body: formData,
    });
    if (!res.ok) throw new Error(`Failed to upload ${file.name}`);
  }
}

export async function deleteDocument(docId: string): Promise<void> {
  const res = await fetch(`${BASE}/documents-delete/${docId}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to delete document');
}

export async function downloadDocument(docId: string): Promise<string> {
  try {
    const res = await fetch(`${BASE}/documents-download/${docId}`, { headers: authHeaders() });
    if (!res.ok) return '';
    const data = await res.json();
    return data.download_url || '';
  } catch {
    return '';
  }
}
